import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
		flexDirection: 'column',
    fontSize: "7pt",
    fontFamily: 'Helvetica',
    margin: '0px 10px',
  },
  bold:{
    fontFamily: 'Helvetica-Bold',
  },
  tCenter: {
    textAlign:'center'
  },
  table:{
    width: '100%',
    border: "1pt solid black",
    borderBottom:'none',
    borderRight:'none',
    marginTop: '20px'
  },
  tableRow:{
    flexDirection: 'row',
    borderBottom:'1pt solid black',
    flexWrap: 'nowrap',
  },
  column:{
    borderRight:'1pt solid black',
    padding: "2pt"
  },
  tableHeaderRow:{
    flexDirection: 'row',
    borderBottom:'1pt solid black',
    borderRight:'1pt solid black',
    flexWrap: 'nowrap',
    fontWeight: 'bold',
  },
  tableHeader:{
    textAlign:'center',
    fontSize:'12pt',
    padding: '7pt',
    width: '100%',
    fontWeight: 'bold',
  },
  tableFooter:{
    fontSize:'7pt',
    padding: '5pt 2pt',
  },
  tableFooterValor:{
    paddingLeft:'5pt'
  },
  textRight:{
    textAlign:'right'
  },
  columnBasic:{
    padding: "2pt"
  },
  c2:{
    width: "13%"
  },
  c3:{
    width: "14%"
  },
  c4:{
    width: "7%"
  },
  c5:{
    width: "10%"
  },
  c6:{
    width: "7%"
  },
  c7:{
    width: "7%"
  },
  c8:{
    width: "8.5%"
  },
  c8b:{
    width: "8.5%"
  },
  c8c:{
    width: "8.5%"
  },
  c9:{
    width: "8.5%"
  },
  c11:{
    width: "8%"
  },
  cTotalLabel:{
    width: "58%",
  },
})

export default function RelatorioPdfConsulta ({
  data, totalQuitadas, totalAVencer, totalVencidas,
  totalBrutaQuitadas, totalBrutaAVencer, totalBrutaVencidas,
  totalCompraBoletoQuitadas, totalCompraBoletoAVencer, totalCompraBoletoVencidas,
  totalPagamentoQuitadas, totalPagamentoAVencer, totalPagamentoVencidas
}) {

  function exibirDataFormatada(dataAF) {
    if(dataAF != null){
      let dataF = new Date(dataAF)
      return dataF.toLocaleDateString('pt-BR')
    } else {
      return ""
    }
  }

  function exibirValorMonetarioBr(valor) {
    if (valor != null) {
      return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    } else {
      let zero = 0.0
      return zero.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    }
  }

  // Filtra faturas rejeitadas (Melhoria 8 — não exibir rejeitadas no PDF)
  const dataFiltrada = (data || []).filter((f) => f.rejeitada !== true);

  // Cabeçalho de colunas reutilizável
  function CabecalhoColunas() {
    return (
      <View style={[styles.tableRow]}>
        <Text style={[styles.column, styles.bold, styles.c2]}>Agenciador</Text>
        <Text style={[styles.column, styles.bold, styles.c3]}>Consumidor Final</Text>
        <Text style={[styles.column, styles.bold, styles.c4]}>Nº NF</Text>
        <Text style={[styles.column, styles.bold, styles.c5]}>Pagamento</Text>
        <Text style={[styles.column, styles.bold, styles.c6]}>Emissão</Text>
        <Text style={[styles.column, styles.bold, styles.c7]}>Vencimento</Text>
        <Text style={[styles.column, styles.bold, styles.c8]}>Valor Bruto</Text>
        <Text style={[styles.column, styles.bold, styles.c8b]}>Vl. Compra/Boleto</Text>
        <Text style={[styles.column, styles.bold, styles.c8c]}>Vl. Pagamento</Text>
        <Text style={[styles.column, styles.bold, styles.c9]}>Valor a Pagar</Text>
        <Text style={[styles.column, styles.bold, styles.c11]}>Status da Comissão</Text>
      </View>
    );
  }

  return(
    <Document title={'Relatório PDF'}>
      <Page wrap size='A4' orientation="landscape">
        <View style={styles.page} >
          {/* /////////////////////// */}
          {/* FATURAS QUITADAS */}
          <View style={styles.table}>
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.tableHeader, styles.bold]} >Faturas Quitadas</Text>
            </View>
            <CabecalhoColunas />
            {dataFiltrada.map((fatura) => {
              return(
                <View key={fatura.numeroTransacaoVenda + fatura.prestacao}>
                {fatura.statusFatura === "Quitada" && <View style={[styles.tableRow]} wrap={false}>
                  <Text style={[styles.column, styles.c2]} >{fatura.nomeAgenciador}</Text>
                  <Text style={[styles.column, styles.c3]} >{fatura.nomeCliente}</Text>
                  <Text style={[styles.column, styles.c4, styles.tCenter]} >{fatura.numeroNota + " - " + fatura.prestacao}</Text>
                  <Text style={[styles.column, styles.c5, styles.tCenter]} >{fatura.tipoCobranca}</Text>
                  <Text style={[styles.column, styles.c6]} >{exibirDataFormatada(fatura.dataEmissao)}</Text>
                  <Text style={[styles.column, styles.c7]} >{exibirDataFormatada(fatura.dataVencimento)}</Text>
                  <Text style={[styles.column, styles.c8, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoBruta)}</Text>
                  <Text style={[styles.column, styles.c8b, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}</Text>
                  <Text style={[styles.column, styles.c8c, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfe)}</Text>
                  <Text style={[styles.column, styles.c9, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorAPagar)}</Text>
                  <Text style={[styles.column, styles.c11]} >{fatura.statusComissao || fatura.statusPagamentoComissao}</Text>
                </View>}
                </View>
              )
            })}
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.column, styles.bold, styles.textRight, styles.cTotalLabel, styles.tableFooter ]} >Total:</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8, styles.tableFooter ]} >{exibirValorMonetarioBr(totalBrutaQuitadas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8b, styles.tableFooter ]} >{exibirValorMonetarioBr(totalCompraBoletoQuitadas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8c, styles.tableFooter ]} >{exibirValorMonetarioBr(totalPagamentoQuitadas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c9, styles.tableFooter ]} >{exibirValorMonetarioBr(totalQuitadas)}</Text>
              <Text style={[styles.column, styles.c11, styles.tableFooter ]}></Text>
            </View>
          </View>
          {/* /////////////////////// */}
          {/* FATURAS A VENCER */}
          <View style={styles.table}>
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.tableHeader, styles.bold]} >Faturas a Vencer</Text>
            </View>
            <CabecalhoColunas />
            {dataFiltrada.map((fatura) => {
              return(
                <View key={fatura.numeroTransacaoVenda + fatura.prestacao}>
                {fatura.statusFatura === "A Vencer" && <View style={[styles.tableRow]} wrap={false}>
                  <Text style={[styles.column, styles.c2]} >{fatura.nomeAgenciador}</Text>
                  <Text style={[styles.column, styles.c3]} >{fatura.nomeCliente}</Text>
                  <Text style={[styles.column, styles.c4, styles.tCenter]} >{fatura.numeroNota + " - " + fatura.prestacao}</Text>
                  <Text style={[styles.column, styles.c5, styles.tCenter]} >{fatura.tipoCobranca}</Text>
                  <Text style={[styles.column, styles.c6]} >{exibirDataFormatada(fatura.dataEmissao)}</Text>
                  <Text style={[styles.column, styles.c7]} >{exibirDataFormatada(fatura.dataVencimento)}</Text>
                  <Text style={[styles.column, styles.c8, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoBruta)}</Text>
                  <Text style={[styles.column, styles.c8b, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}</Text>
                  <Text style={[styles.column, styles.c8c, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfe)}</Text>
                  <Text style={[styles.column, styles.c9, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorAPagar)}</Text>
                  <Text style={[styles.column, styles.c11]} >{fatura.statusComissao || fatura.statusPagamentoComissao}</Text>
                </View>}
                </View>
              )
            })}
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.column, styles.bold, styles.textRight, styles.cTotalLabel, styles.tableFooter ]} >Total:</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8, styles.tableFooter ]} >{exibirValorMonetarioBr(totalBrutaAVencer)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8b, styles.tableFooter ]} >{exibirValorMonetarioBr(totalCompraBoletoAVencer)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8c, styles.tableFooter ]} >{exibirValorMonetarioBr(totalPagamentoAVencer)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c9, styles.tableFooter ]} >{exibirValorMonetarioBr(totalAVencer)}</Text>
              <Text style={[styles.column, styles.c11, styles.tableFooter ]}></Text>
            </View>
          </View>
          {/* /////////////////////// */}
          {/* FATURAS VENCIDAS */}
          <View style={styles.table}>
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.tableHeader, styles.bold]} >Faturas Vencidas</Text>
            </View>
            <CabecalhoColunas />
            {dataFiltrada.map((fatura) => {
              return(
                <View key={fatura.numeroTransacaoVenda + fatura.prestacao}>
                {fatura.statusFatura === "Vencida" && <View style={[styles.tableRow]} wrap={false}>
                  <Text style={[styles.column, styles.c2]} >{fatura.nomeAgenciador}</Text>
                  <Text style={[styles.column, styles.c3]} >{fatura.nomeCliente}</Text>
                  <Text style={[styles.column, styles.c4, styles.tCenter]} >{fatura.numeroNota + " - " + fatura.prestacao}</Text>
                  <Text style={[styles.column, styles.c5, styles.tCenter]} >{fatura.tipoCobranca}</Text>
                  <Text style={[styles.column, styles.c6]} >{exibirDataFormatada(fatura.dataEmissao)}</Text>
                  <Text style={[styles.column, styles.c7]} >{exibirDataFormatada(fatura.dataVencimento)}</Text>
                  <Text style={[styles.column, styles.c8, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoBruta)}</Text>
                  <Text style={[styles.column, styles.c8b, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}</Text>
                  <Text style={[styles.column, styles.c8c, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorComissaoNfe)}</Text>
                  <Text style={[styles.column, styles.c9, styles.textRight]} >{exibirValorMonetarioBr(fatura.valorAPagar)}</Text>
                  <Text style={[styles.column, styles.c11]} >{fatura.statusComissao || fatura.statusPagamentoComissao}</Text>
                </View>}
                </View>
              )
            })}
            <View style={[styles.tableHeaderRow]} >
              <Text style={[styles.column, styles.bold, styles.textRight, styles.cTotalLabel, styles.tableFooter ]} >Total:</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8, styles.tableFooter ]} >{exibirValorMonetarioBr(totalBrutaVencidas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8b, styles.tableFooter ]} >{exibirValorMonetarioBr(totalCompraBoletoVencidas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c8c, styles.tableFooter ]} >{exibirValorMonetarioBr(totalPagamentoVencidas)}</Text>
              <Text style={[styles.column, styles.bold, styles.textRight, styles.c9, styles.tableFooter ]} >{exibirValorMonetarioBr(totalVencidas)}</Text>
              <Text style={[styles.column, styles.c11, styles.tableFooter ]}></Text>
            </View>
          </View>

          {/* /////////////////////// */}
        </View>
      </Page>
    </Document>
  )

}
